
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    products: {
      type: Array,
      default: () => { },
    },
  },
  computed: {
    ...mapState(['menu', 'order']),
  },
  methods: {
    image(item) {
      let image = 'https://storyblok.pleinaircdn.com/f/110020/62x62/7e05138e6f/placeholder.svg'
      if (this.menu) {
        this.menu.categories.forEach(category => {
          category.products.forEach(menuItem => {
            if (menuItem.name == item.name) {
              if (process.env.GW_ENV === 'stage' || process.env.GW_ENV === 'prod') {
                image = 'https://olo-images-live.imgix.net/'+menuItem.images[1].filename
              } else {
                image = 'https://olo-images-sandbox.imgix.net/' + menuItem.images[1].filename
              }
            }
          })
        })
      }
      return image
    },
    description(item) {
      if (item.choices && item.choices.length) {
        let desc = item.choices[0].name
        if (item.choices[0].quantity > 1) {
          desc = desc + ' (x' + item.choices[0].quantity + ')'
        }
        if (item.choices) {
          item.choices.forEach((choice, i) => {
            if (i > 0) {
              desc = desc + ', ' + choice.name
              if (choice.quantity > 1) {
                desc = desc + ' (x' + choice.quantity + ')'
              }
            }
          })
        }
        if (item.instructions) {
          desc = desc + ' (' + item.instructions + ')'
        }
        return desc
      }
    },
  }
}
